import { __extends } from "tslib";
var NoSDKOrDataProvidedError = /** @class */ (function (_super) {
    __extends(NoSDKOrDataProvidedError, _super);
    function NoSDKOrDataProvidedError() {
        var _newTarget = this.constructor;
        var _this = _super.call(this, "\nNo `Wix`, `editorSDK` or `publicData` was passed to TPASettingsProvider.\nIn order to work with tpa-settings, you have to pass either Wix SDK or Editor SDK for Settings panel mode or publicData for Widget mode.\n") || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return NoSDKOrDataProvidedError;
}(Error));
export { NoSDKOrDataProvidedError };
//# sourceMappingURL=NoSDKOrDataProvidedError.js.map